import { Slide } from '@/components/core/Slide';
import audioFile from './32-metalektro.mp3';

const autoNextDuration = 48000;
const transcript = `
  Voor de metalektro sector, dus machinebouw en hightech bedrijven, zijn er ook specifieke toepassingen.

  AI-gestuurde simulaties en prototyping maken het mogelijk om ontwerpen te verbeteren en testomgevingen 
  te simuleren zonder fysieke prototypes te hoeven maken.

  Digitale tweelingen zijn virtuele kopieën van machines die AI kan maken om prestaties te monitoren en 
  te optimaliseren.

  Met automatische foutdetectie kunnen AI-gestuurde camera's microfouten in componenten herkennen die 
  met het blote oog niet zichtbaar zijn.

  En AI-chatbots voor service en onderhoud kunnen storingen diagnosticeren en technici begeleiden bij reparaties.

  Wederom: snellere innovatie, lagere kosten voor productontwikkeling, en minder fouten.
`;

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      autoNext={autoNextDuration}
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1 className="text-4xl font-bold mb-8">Metalektro (machinebouw & hightech) ⚙️</h1>

        <ul className="space-y-4 list-disc">
          <li>AI-gestuurde simulaties en prototyping: Ontwerpen verbeteren zonder prototypes</li>
          <li>Digitale tweelingen: Virtuele kopieën van machines om prestaties te optimaliseren</li>
          <li>Automatische foutdetectie: Herkennen van microfouten die niet zichtbaar zijn</li>
          <li>AI-chatbots voor service & onderhoud: Storingen diagnosticeren</li>
        </ul>
      </div>
    </Slide>
  );
};
